import React, { useState } from "react";
import PropTypes from "prop-types";
import { scrollIntoView } from "utils/helper";
import ContactDetailsDisplay from "./contactDetailsDisplay";
import EditContactDetails from "./editContactDetails";
import useContactDetails from "./useContactDetails";

function ContactDetails({ isShowEditIcon = true }) {
  const [isEditMode, setIsEditMode] = useState(false);
  const { onEditContactDetails, isLoading } = useContactDetails();

  const handleEditClick = () => setIsEditMode(true);

  const handleDiscard = () => {
    setIsEditMode(false);
    scrollIntoView("contactDetailsSection");
  };

  const handleSave = async (values) => {
    await onEditContactDetails(values);
    setIsEditMode(false);
  };

  if (isEditMode) {
    return (
      <EditContactDetails
        onDiscard={handleDiscard}
        onSave={handleSave}
        isLoading={isLoading}
      />
    );
  }

  return (
    <ContactDetailsDisplay
      onEditClick={handleEditClick}
      isShowEditIcon={isShowEditIcon}
    />
  );
}

ContactDetails.propTypes = {
  isShowEditIcon: PropTypes.bool,
};

export default ContactDetails;

